<template>
  <v-navigation-drawer v-model="drawer" app temporary>
    <v-list class="pa-1" color="primary--text">
      <v-list-item>
        <v-list-item-avatar>
          <img src="img/corner.png" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ getLoggedInUser.name }} {{ getLoggedInUser.surname }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list class="pt-0" dense flat color="primary--text">
      <v-list-item-group>
        <v-divider></v-divider>

        <v-list-item :to="{ name: 'home' }" exact>
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('nav.home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <span v-if="getLoggedInUser.isadmin">
          <v-list-item disabled>
            <v-list-item-icon>
              <v-icon>supervisor_account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold primary--text body-2">
                {{ $t('nav.admin.admin') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'adminUser' }">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2">{{ $t('nav.admin.users') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'adminContact' }">
            <v-list-item-icon>
              <v-icon>mdi-card-account-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2">{{ $t('nav.admin.contacts') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> 
          <v-list-item :to="{ name: 'adminI18N' }">
            <v-list-item-icon>
              <v-icon>language</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="pl-2">{{ $t('nav.admin.translations') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </span>

      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["value"],
  data() {
    return {
      ndd: null
    };
  },
  computed: {
    ...mapGetters(["getLoggedInUser"]),
    drawer: {
      get() {
        return this.ndd;
      },
      set(value) {
        this.ndd = value;
        this.$emit("input", value);
      }
    },
  },
  watch: {
    value() {
      this.ndd = this.value;
    }
  }
};
</script>

<style>
  .v-list-item:hover {
    background: rgb(243, 240, 240);
  }
</style>